export const ROUTING_NAMES = {
  home: "/",
  payFee: "/pay-fee",
  handleJuspayResponse: "/handleJuspayResponse",
  easebuzzReturn: "/easebuzz",
  services: "/services",
  features: "/features",
  pricing: "/pricing",
  aboutUs: "/about-us",
  partners: "/become-a-partners",
  careers: "/careers",
  contact_us: "/contact-us",
  refundPolicy: "/refund-policy",
  govermentCertified: "/goverment-certified",
  termAndConditions: "/term-and-conditions",
  privacyPolicy: "/privacy-policy",
  security: "/security",
  blogs: "/blogs",
};
